import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {
  selectIsPremium,
  selectIsProOrPartyPass,
} from '~/CreateFabricGreetingCard/reducers/fabricTemplate/selectors';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {selectLoaded} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Sections} from '~/common/fabric/CreateDesign/constants';
import {useEnvelope} from '~/common/fabric/CreateDesign/components/Envelope/actions/useEnvelope';
import {useNavigator} from '~/common/fabric/CreateDesign/components/NavBottom/useNavigator';
import {StickersCanvas} from '~/common/fabric/CreateDesign/components/Stamp/StickersCanvas';
import linerShading from '~/../images/liner_shading.png';

import './Envelope.sass';

export const Envelope = ({
  id,
  type,
  onLoad,
  redirectTo,
  message,
  className,
  selectedLiner,
  selectedStamp,
  style = {},
  canvas = false,
  parentNode = '',
}) => {
  const ref = useRef();
  const isPremium = useSelector(selectIsPremium);
  const {selectedEnvelope} = useEnvelope();
  const isLargishAndUp = useIsLargishAndUp();
  const loaded = useSelector(selectLoaded);
  const isProOrPartyPass = useSelector(selectIsProOrPartyPass);
  const isMobile = !isLargishAndUp;
  const navigate = useNavigator({
    isMobile,
    disableAutoOpenEditor: redirectTo === Sections.CARD_DESIGN,
  });

  const envelopeSizer = document.getElementById(parentNode);
  useEffect(() => {
    if (ref.current) {
      const setCurrentDimensions = () => {
        if (isMobile && envelopeSizer) {
          ref.current.style.height = `${envelopeSizer.offsetWidth}px`;
          ref.current.style.width = `${envelopeSizer.offsetHeight}px`;
        }
      };

      setCurrentDimensions();

      window.addEventListener('resize', setCurrentDimensions);

      return () => {
        window.removeEventListener('resize', setCurrentDimensions);
      };
    }

    return () => {};
  }, [isMobile, envelopeSizer]);

  return isPremium || isProOrPartyPass ? (
    <div
      ref={ref}
      onClick={loaded && redirectTo ? () => navigate(redirectTo) : undefined}
      onKeyDown={loaded && redirectTo ? () => navigate(redirectTo) : undefined}
      className={`envelope_image__wrapper envelope_image__wrapper__${type} ${
        redirectTo && 'envelope_image__wrapper--clickable'
      } ${!loaded && 'envelope_image__wrapper--clickable--disabled'} ${className}`}
      style={style}
      role="button"
      tabIndex="0"
    >
      {selectedEnvelope && (
        <img
          src={selectedEnvelope[type]}
          className="envelope_image"
          id={id}
          onLoad={onLoad}
          alt="Envelope"
        />
      )}
      {selectedLiner && (
        <>
          <img
            alt="envelope-liner-shadow"
            src={linerShading}
            className="envelope_image__wrapper__liner__shadow"
          />
          <img
            src={selectedLiner}
            className="envelope_image__wrapper__liner"
            alt="Envelope Liner"
          />
        </>
      )}
      {selectedStamp && (
        <img className="envelope_image__wrapper__stamp" src={selectedStamp} alt="Stamp" />
      )}
      {message && (
        <div className="envelope_image__wrapper__text">
          <span style={{color: selectedEnvelope?.text_color}}>{message}</span>
        </div>
      )}
      {canvas && <StickersCanvas className="envelope_image__wrapper__canvas" />}
    </div>
  ) : null;
};
